import { Form, Popover } from "antd";
import { FC, HTMLAttributes } from "react";
import { useTranslation } from "react-i18next";
import cn from "classnames";
import { DownIcon, PassengerIcon } from "src/assets/Icons";
import { INITIAL_PASSENGERS } from "../../../../constants";
import { countPassengers } from "../utils";
import PassengerSelectContent from "../../PassengerSelectContent/PassengerSelectContent";

const PassengerSelectWeb: FC<{ wrapperProps?: HTMLAttributes<HTMLDivElement> }> = ({ wrapperProps }) => {
  const { t } = useTranslation();
  const value = Form.useWatch("passengers") ?? INITIAL_PASSENGERS;
  const numberOfPassengers = countPassengers(value);

  return (
    <Popover arrow={false} trigger={["click"]} placement="bottom" forceRender content={<PassengerSelectContent />}>
      <div className={cn("flex w-full items-center gap-2 text-font-minimal hover:text-background-primary md:justify-center font-semibold", wrapperProps?.className)}>
        <PassengerIcon />
        {numberOfPassengers} {numberOfPassengers === 1 ? t("Flights.search.passenger") : t("Flights.search.passengers")}
        <span className="hidden h-4 w-4 items-center justify-center md:flex">
          <DownIcon />
        </span>
      </div>
    </Popover>
  );
};

export default PassengerSelectWeb;
